import React from 'react';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './standard_page.module.css';

type StandardPageStyles = {
  background: string;
  container: string;
  fullBackground: string;
  fullContainer: string;
  fixedBackground: string;
  fixedContainer: string;
};

const themedStyles: ThemedStyles<StandardPageStyles> = {
  [Theme.DAYLIGHT]: {
    background: baseStyles.daylightBackground,
    container: baseStyles.container,
    fullBackground: baseStyles.daylightFullBackground,
    fullContainer: baseStyles.fullContainer,
    fixedBackground: baseStyles.daylightFixedBackground,
    fixedContainer: baseStyles.fixedContainer,
  },
  [Theme.MIDNIGHT]: {
    background: baseStyles.midnightBackground,
    container: baseStyles.container,
    fullBackground: baseStyles.midnightFullBackground,
    fullContainer: baseStyles.fullContainer,
    fixedBackground: baseStyles.midnightFixedBackground,
    fixedContainer: baseStyles.fixedContainer,
  },
};

export type StandardPageProps = {
  onScroll?: React.UIEventHandler<HTMLDivElement>;
  children: React.ReactNode;
};

export const StandardPage = React.memo(({ onScroll, children }: StandardPageProps) => {
  const styles = useStyles(themedStyles);
  return (
    <div className={styles.background} onScroll={onScroll}>
      <div className={styles.container}>
        {children}
      </div>
    </div>
  );
});
StandardPage.displayName = 'StandardPage';

export const FullStandardPage = React.memo(({ onScroll, children }: StandardPageProps) => {
  const styles = useStyles(themedStyles);
  return (
    <div className={styles.fullBackground} onScroll={onScroll}>
      <div className={styles.fullContainer}>
        {children}
      </div>
    </div>
  );
});
FullStandardPage.displayName = 'FullStandardPage';

export const FixedStandardPage = React.memo(({ onScroll, children }: StandardPageProps) => {
  const styles = useStyles(themedStyles);
  return (
    <div className={styles.fixedBackground} onScroll={onScroll}>
      <div className={styles.fixedContainer}>
        {children}
      </div>
    </div>
  );
});
FixedStandardPage.displayName = 'FixedStandardPage';
